(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      if (entry.target.classList.contains('mm-fade')) {
        entry.target.classList.add('is-visible');
      } else {
        entry.target.classList.add('mm-revealed');
      }
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  function prepare(root) {
    var scope = root || document;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    // Read geometry before changing classes; interleaving these steps forces
    // the browser to recalculate layout once for each section.
    var fades = Array.from(scope.querySelectorAll('.mm-fade:not([data-mm-reveal-bound])')).map(function (element) {
      return { element: element, visible: !!element.closest('.lp') || element.getBoundingClientRect().top < viewportHeight * 0.9 };
    });
    var main = scope.id === 'MainContent' ? scope : scope.querySelector('#MainContent');
    var sections = main ? Array.from(main.querySelectorAll(':scope > .shopify-section:not([data-mm-reveal-bound])')).map(function (section, index) {
      return {
        element: section,
        visible: index === 0 || section.hasAttribute('data-mm-no-reveal') ||
          !!section.querySelector('.mm-fade, .ga-fade, .ga2-fade, .ga3-fade, .lp-fade') ||
          section.getBoundingClientRect().top < viewportHeight * 0.9
      };
    }) : [];

    fades.forEach(function (item) {
      item.element.setAttribute('data-mm-reveal-bound', '');
      if (item.visible) item.element.classList.add('is-visible');
      else observer.observe(item.element);
    });
    sections.forEach(function (item) {
      item.element.setAttribute('data-mm-reveal-bound', '');
      if (item.visible) return;
      item.element.classList.add('mm-reveal-init');
      observer.observe(item.element);
    });
  }

  function init() {
    prepare(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    prepare(event.target);
  });
})();
